module.exports = __webpack_public_path__ + "static/img/news_xiangqing_ttu1.68b942d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/news_xiangqing_ttu1.png
// module id = ny93
// module chunks = 0